import { css, styled } from 'styled-components';
import { InputWrapperProps } from '.';
import SVG from '../SVG';
import { CSSProperties } from 'react';

export const AppWrapper = styled.div`
  display: block;
`;

export const Field = styled.div`
  position: relative;
  width: 100%;
`;

export const Label = styled.label<InputWrapperProps>`
  ${({
    $fontSize,
    $isFocused,
    $inputPaddingLeft,
    $labelScale,
    $inputHeight,
    $transitionTime,
    $hasError,
    $fontColor,
    $activeLabelColor,
    $disabled = false,
  }) => {
    const color = $hasError ? 'red' : '#00000099';
    return css`
      position: absolute;
      display: flex;
      align-items: center;
      transition:
        transform ${$transitionTime}ms,
        color ${$transitionTime}ms;
      transform-origin: 0 0;
      transform: ${!$isFocused
        ? `matrix(1, 0, 0, 1, ${$inputPaddingLeft}, 0)`
        : `matrix(${$labelScale}, 0, 0, 
        ${$labelScale}, 0, -${$inputHeight / 2 + 3})`};
      cursor: ${$disabled ? 'default' : 'text'};
      color: ${$isFocused ? $activeLabelColor : $fontColor};
      height: 100%;
      z-index: 5;
      font-size: ${$fontSize}px;
    `;
  }}
`;

export const InputWrapper = styled.div<InputWrapperProps>`
  ${({ $borderRadius, $backgroundColor }) => css`
    display: flex;
    position: relative;
    background: ${$backgroundColor};
    border-radius: ${$borderRadius}px;
    align-items: center;
  `}
`;

export const InputLeft = styled.div<any>`
  ${({}) => css`
    width: 100%;
  `}
`;
export const Input = styled.input<InputWrapperProps>`
  ${({ $borderRadius, $fontSize, $fontColor }) => css`
    display: flex;
    border: none;
    outline: none;
    font-size: ${$fontSize}px;
    background: transparent;
    height: 24px;
    padding: 8px 12px 6px 12px;
    width: 100%;
    border-radius: ${$borderRadius}px;
    color: ${$fontColor};
    &:-webkit-autofill {
      -webkit-box-shadow: 0 0 0px 1000px transparent inset;
      transition: background-color 5000s ease-in-out 0s;
    }
  `}
`;

export const Error = styled.p<InputWrapperProps>`
  ${({ $hasError, $transitionTime }) => css`
    transition: color ${$transitionTime * 2}ms;
    color: ${$hasError ? 'red' : 'transparent'};
    min-height: 18.4px;
    text-align: start;
    margin: 10px 0;
  `}
`;

export const IconSearchWrapper = styled(SVG.Icon.Search)`
  ${() => css`
    cursor: pointer;
  `}
`;

export const IconLoadingWrapper = styled(SVG.Icon.Loader)`
  ${() => css`
    cursor: pointer;
  `}
`;

export const IconAngle = styled<any>(SVG.Icon.Angle)`
  ${({ $isFocused, $disabled }) => css`
    display: flex;
    transition:
      rotate 500ms,
      scale 500ms;
    rotate: ${$isFocused ? '-90deg' : '90deg'};
    cursor: ${$disabled ? 'default' : 'pointer'};
    fill: ${$disabled ? '#a7a7a7' : '#513389'};
  `}
`;

export const IconLoader = styled<any>(SVG.Icon.Loader)`
  ${() => css``}
`;

interface DropdownListProps {
  $isFocused: boolean;
  $height: number;
  $inputWidth: number;
  $top: number;
  $fontSize?: number;
}

interface DropdownItemProps {
  $isSelectedItem?: boolean;
  $isHover?: boolean;
}

export const Mark = styled.div<{
  top: CSSProperties['top'];
  left: CSSProperties['left'];
}>`
  ${({ top, left }) => css`
    position: fixed;
    top: ${top}px;
    left: ${left}px;
    z-index: 10;
  `}
`;

export const DropdownList = styled.ul<DropdownListProps>`
  ${({
    $isFocused,
    $height,
    $top,
    $fontSize,
    $inputWidth,
  }: DropdownListProps) => css`
    position: fixed;
    list-style: none;
    border-color: ${$isFocused ? '#bdbdbd' : 'transparent'};
    border-radius: 4px;
    color: #212121;
    width: ${$inputWidth}px;
    padding-left: 0;
    top: ${$top}px;
    height: ${$height}px;
    margin-top: 2px;
    z-index: 6;
    background-color: white;
    box-shadow: ${$isFocused ? '0px 0px 8px 8px rgba(0, 0, 0, 0.2)' : 'none'};
    overflow: auto;
    font-size: ${$fontSize ?? '14px'};
  `}
`;

export const DropdownItem = styled.li<DropdownItemProps>`
  ${({ $isSelectedItem = false, $isHover = false }: DropdownItemProps) => css`
    cursor: pointer;
    background-color: ${$isSelectedItem
      ? '#D9D9D9'
      : $isHover
        ? '#EEEEEE'
        : 'transparent'};
    padding: 5px 1.2rem;
    margin: 0.2rem;
    border-radius: 4px;
    height: fit-content;
    z-index: 5;
  `}
`;

export const DropdownContainer = styled.div``;
